import { GoalDetailCardSection, InProgressSpinningLogo } from './Styled';
import { GoalDetailsPredictionSectionProps } from '../types';
import { TEST_IDS } from '../constants';

export const GoalDetailsPredictionSection = ({ children }: GoalDetailsPredictionSectionProps) => {
  return (
    <GoalDetailCardSection>
      <InProgressSpinningLogo data-test={TEST_IDS.SpinningLogo} size={24} />
      <div>{children}</div>
    </GoalDetailCardSection>
  );
};
